/* eslint-disable camelcase */
import { addZero } from '../../../../../utils/filters'
import { getTeamLabelByNumber } from '../../utils/utils'

export default {
  // 'this' - $store
  byActionType: {
    numberOfPlayersChangeEvents ({ extra: { team1, team2 } }) {
      if (!team1 || !team2) return
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    }
  },
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' ({ extra }) {
      const {
        kits,
        matchFormat,
        overtimeFormat,
        has_golden_set,
        timer_speed_up: timerSpeedUp
      } = extra

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerSpeedUp,
        has_golden_set
      })
    },
    'START_SHOOTOUT' (event) {
      this.setPenaltyShootouts(event)
    },
    'GOAL' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })
    },
    'MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'BALL_ZONE' ({ extra }) {
      this.setIngameProperty({
        property: 'zone',
        value: extra.zone
      })
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      this.setIngameProperty({
        property: 'leftSideTeam',
        value: TeamNumber
      })
    },
    'PENALTY_FINISH' (event) {
      this.editPeriodScore(event)
    },
    'START_PERIOD' ({ GamePeriod, extra: { team1, team2 } }) {
      if (GamePeriod === 1) return

      const { getIngameData } = this
      const { leftSideTeam } = getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })

      if (!team1 || !team2) return

      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'DEFENSE' (event) {
      const { eventInfo, extra, TeamNumber } = event

      if (!extra) return eventInfo.title

      const { homeTeamTitle, awayTeamTitle } = this
      const { meters } = extra
      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${eventInfo.title} ${meters} ${this.$t('meters')} / ${teamTitle}`
    },

    'ATTACK' (event) {
      const { eventInfo, extra, TeamNumber } = event

      if (!extra) return eventInfo.title

      const { homeTeamTitle, awayTeamTitle } = this
      const { meters } = extra
      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${eventInfo.title} ${meters} ${this.$t('meters')} / ${teamTitle}`
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  eventPlaytimeFunction (event) {
    const { Playtime, GamePeriod } = event

    if (!Playtime || !GamePeriod) return '00:00'

    const { getFormats } = this.getters
    const {
      matchFormat: {
        duration: mainDuration
      }
    } = getFormats
    const secondsCount = Playtime / 1000
    const minutes = Math.floor(secondsCount / 60)
    const seconds = Math.floor(secondsCount % 60)
    const compareValue = GamePeriod * mainDuration
    const needToTransform = compareValue < minutes || (compareValue === minutes && seconds > 0)

    if (!needToTransform) return `${addZero(minutes)}:${addZero(seconds)}`
    const maintimeMinutes = mainDuration * GamePeriod

    return `${maintimeMinutes}:00 (${minutes - maintimeMinutes}:${addZero(seconds)})`
  }
}
